<template>
  <div>
    <breakpoint-btn></breakpoint-btn>
    <v-navigation-drawer v-if="isMobile" v-model="openDrawer" fixed temporary class="mobile-nav">
      <MobileMenu :open="openDrawer" @close="openDrawer = false" />
    </v-navigation-drawer>
    <v-app-bar
      dark
      v-scroll="handleScroll"
      id="header"
      :class="{ fixed: fixed, 'open-drawer': openDrawer }"
      class="header"
      fixed
      app
      v-bind="$attrs"
    >
      <v-container fluid>
        <div class="header-content">
          <nav :class="{ invert: invert }" class="nav-logo nav-menu">
            <v-btn
              id="hamburger-btn"
              v-if="isMobile"
              :class="{ 'is-active': openDrawer }"
              class="hamburger hamburger--spin mobile-menu"
              text
              icon
              @click.stop="handleToggleOpen"
            >
              <span class="hamburger-box">
                <span class="bar hamburger-inner" />
              </span>
            </v-btn>
            <div class="logo">
              <router-link v-if="invert" :to="{ name: 'welcome' }">
                <img :src="logo" alt="B" />
                <span v-if="!isMobile && !dense">
                  {{ brand.name }}
                </span>
              </router-link>

              <scrollactive :modify-url="false" v-if="!invert && loaded" tag="span">
                <app-link :to="{ name: 'welcome' }" class="anchor-link scrollactive-item">
                  <div class="d-flex align-center" :class="{ 'my-1': !isMobile && !dense }">
                    <img :src="logo" alt="B" class="mr-3" />
                    <span class="white--text text-h5" v-if="isMobile || dense">
                      <strong>{{ brand.name }}</strong>
                    </span>
                  </div>
                  <strong v-if="!isMobile && !dense">
                    {{ brand.name }}
                  </strong>
                </app-link>
              </scrollactive>
            </div>
            <div v-if="isDesktop && $route.name === 'welcome'">
              <scrollactive
                :modify-url="false"
                v-if="loaded"
                :offset="navOffset"
                active-class="active"
                tag="ul"
              >
                <li v-for="(item, index) in menuList" :key="index">
                  <v-btn
                    v-if="!invert"
                    :href="item.url"
                    class="anchor-link scrollactive-item text-capitalize"
                    text
                    @click="setOffset(item)"
                  >
                    {{ $t(item.name) }}
                  </v-btn>
                  <v-btn v-if="invert" :href="'/' + item.url" text>
                    {{ $t(item.name) }}
                  </v-btn>
                </li>
                <!-- <li>
                  <v-btn :href="link.saas.contact" text>
                    <span v-t="'Contact'" />
                  </v-btn>
                </li> -->
              </scrollactive>
            </div>
          </nav>

          <nav :class="{ invert: invert }" class="nav-menu">
            <app-language-selector v-if="$vuetify.breakpoint.mdAndUp"></app-language-selector>
            <nav-menu-buttons></nav-menu-buttons>
            <!-- <setting-menu :invert="invert" /> -->
          </nav>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<style lang="scss" scoped>
@import "./header-style.scss";

// @media only screen and (max-width: 500px) {
//   .nav-menu-buttons {
//     display: none;
//   }
// }
</style>

<script>
import AppLanguageSelector from "../app-language/AppLanguageSelector";
import logo from "@/landing/static/logo.svg";

import link from "@/landing/static/text/link";
import brand from "@/landing/static/text/brand";
// import Hidden from '../Hidden'
import { getMenuList } from "./menu";
import Settings from "./Settings";
import MobileMenu from "./MobileMenu";
import NavMenuButtons from "./NavMenuButtons";
// import { fragment } from "vue-fragment";

export default {
  components: {
    "setting-menu": Settings,
    AppLanguageSelector,
    // Hidden,
    MobileMenu,
    // fragment,
    NavMenuButtons,
  },
  props: {
    invert: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logo: logo,
      link: link,
      loaded: false,
      brand: brand,
      section: 0,
      fixed: this.dense ? true : false,
      openDrawer: null,
      navOffset: 80,
      menuList: getMenuList(),
    };
  },
  mounted() {
    this.loaded = true;
  },
  methods: {
    handleScroll: function () {
      if (this.dense) return (this.fixed = true);
      if (window.scrollY > 80) {
        return (this.fixed = true);
      }
      return (this.fixed = false);
    },
    setOffset: function (item) {
      if (!item.offset) return;
      this.navOffset = item.offset;
    },
    handleToggleOpen: function () {
      this.openDrawer = !this.openDrawer;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
      //   const mdDown = this.$store.state.breakpoints.mdDown;
      //   return mdDown.indexOf(this.$mq) > -1;
    },
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
      //   const lgUp = this.$store.state.breakpoints.lgUp;
      //   return lgUp.indexOf(this.$mq) > -1;
    },
  },
};
</script>
